export enum ClientKind {
    Company = 'Company',
    Person = 'Person'
}
